<div class="confirmation-dialog-container">
    <h2 mat-dialog-title></h2>
    <mat-dialog-content>
        Do you want to remove this tag ? 
        <p>Tag: {{tagName}}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button
        tabindex="-1"
        mat-dialog-close
        mat-raised-button
        color="basic"
        class="mat-button-medium"
        (click)="onConfirmation(false)"
      >
        NO
      </button>
      <button
        mat-raised-button
        color="primary"
        class="mat-button-medium"
       [mat-dialog-close]="true"
        (click)="onConfirmation(true, data)"
      >
        YES
      </button>
    </mat-dialog-actions>
  </div>
  